module.exports = function getResource(label, vars = []) {
    let resources = {
        straighteningLabel: 'Raidissant',
        beingLabel: 'être'
    };

    return resources[label];
};
